import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Option from './Option';
import OptionElement from './OptionElement';
import Options from './Options';
import OptionsStepContainer from './OptionsStepContainer';

class OptionsStep extends Component {
  isOriginSameAsLocation = url => {
    const pageLocation = window.location;
    const URL_HOST_PATTERN = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/;
    const urlMatch = URL_HOST_PATTERN.exec(url) || [];
    const urlparts = {
      protocol:   urlMatch[1] || '',
      host:       urlMatch[2] || '',
      port:       urlMatch[3] || ''
    };

    function defaultPort(protocol) {
      return {'http:':80, 'https:':443}[protocol];
    }

    function portOf(location) {
      return location.port || defaultPort(location.protocol||pageLocation.protocol);
    }

    return !!((urlparts.protocol && (urlparts.protocol  === pageLocation.protocol)) &&
        (urlparts.host && (urlparts.host === pageLocation.host)) &&
        (urlparts.host && (portOf(urlparts) === portOf(pageLocation)))
    );
  }

  onOptionClick = ({ value, url }) => {
    const { triggerNextStep } = this.props;
    if (url && this.isOriginSameAsLocation(url)) {
      window.open(url, '_blank');
    } else if (url) {
      window.open(url, '_blank');
    } else if (value) {
      triggerNextStep({value});
    }
  };

  renderOption = option => {
    const { bubbleOptionStyle, step } = this.props;
    const { user, disabled } = step;
    const { value, label, url, name } = option;

    return (
      <Option key={value} className={name ? 'rsc-os-option ' + name : 'rsc-os-option'} >
        <OptionElement
          className="rsc-os-option-element"
          style={bubbleOptionStyle}
          user={user}
          onClick={() => this.onOptionClick({ value, url })}
          disabled={disabled}
        >
          {label}
        </OptionElement>
      </Option>
    );
  };

  render() {
    const { step } = this.props;
    const { options } = step;

    return (
      <OptionsStepContainer className="rsc-os">
        <Options className="rsc-os-options">
          {Object.keys(options).map(key => options[key]).map(this.renderOption)}
          {options.length > 3 && this.renderOption({ label: 'Další', name: 'other-option' })}
        </Options>
      </OptionsStepContainer>
    );
  }
}

OptionsStep.propTypes = {
  bubbleOptionStyle: PropTypes.objectOf(PropTypes.any).isRequired,
  step: PropTypes.objectOf(PropTypes.any).isRequired,
  triggerNextStep: PropTypes.func.isRequired
};

export default OptionsStep;
